@if (loading() && recipes.length === 0) {
  <!-- First load: inline spinner row -->
  <div class="flex items-center gap-3 px-1 py-6 text-base-content/60">
    <span class="loading loading-spinner loading-sm"></span>
    <span class="text-sm">Rezepte werden gesucht …</span>
  </div>
} @else if (recipes.length === 0) {
  <!-- Empty state -->
  <div class="flex items-center gap-3 rounded-2xl border border-base-300 bg-base-100 p-4">
    <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
      <fa-icon [icon]="faUtensils" size="lg"></fa-icon>
    </span>
    <span class="min-w-0">
      <span class="block font-semibold">Keine Vorschläge</span>
      <span class="block text-sm text-base-content/60">Füge Hauptgang-Rezepte hinzu, um hier Ideen zu erhalten.</span>
    </span>
  </div>
} @else {
  <!-- Horizontal carousel of suggestion cards -->
  <div class="suggestion-carousel" [class.is-refreshing]="loading()">
    @for (recipe of displayedRecipes; track trackById($index, recipe)) {
      <a class="suggestion-card" [routerLink]="['/recipe', recipe.id]">
        <div class="suggestion-card__media">
          @if (recipe.thumbnail_url) {
            <img [src]="recipe.thumbnail_url" [alt]="recipe.title" loading="lazy"/>
          } @else {
            <div class="suggestion-card__placeholder" aria-hidden="true">
              <fa-icon [icon]="faUtensils"></fa-icon>
            </div>
          }
        </div>
        <div class="suggestion-card__body">
          <div class="suggestion-card__title">{{ recipe.title || 'Untitled' }}</div>

          <ui-star-bar
            size="sm"
            [avg]="recipe.rating?.average ?? 0"
            [count]="recipe.rating?.count ?? 0"
            [showValue]="(recipe.rating?.count ?? 0) > 0"/>

          @if (recipe.facets) {
            <app-recipe-facet-badges [facetsValue]="recipe.facets"/>
          }

          <div class="suggestion-card__meta">
            @if (totalMinutes(recipe) > 0) {
              <span>{{ totalMinutes(recipe) }} min</span>
            }
            @if (recipe.servings) {
              <span class="opacity-60">•</span>
              <span>{{ recipe.servings }} Portionen</span>
            }
          </div>
        </div>
      </a>
    }
  </div>
}
